import React from "react";
import { transformToHtml } from "../../../utils/CommonUtils";

export default function AirportBlock({ data, isArrival = false }) {
  if (!data) return null;

  const borderColor = data.airportInfo?.borderColors?.[0] || "transparent";

  return (
    <div
      className={`fsd-block flexCol ${isArrival ? "textRight" : ""}`}
      style={{ borderColor }}
    >
      <div className={`makeFlex hrtlCenter gap10 ${isArrival ? "rowReverse" : ""}`}>
        {data.title && <div className="fontSize14">{transformToHtml(data.title)}</div>}
        {data.airportInfo?.delayInfo && (
          <div
            className="fsd-status-tag ontime fontSize12 boldFont"
            style={{
              color: data.airportInfo.delayInfo.borderColors?.[0] || "#007e7d",
              borderColor: data.airportInfo.delayInfo.borderColors?.[0] || "#007e7d",
            }}
          >
            {transformToHtml(data.airportInfo.delayInfo.text)}
          </div>
        )}
      </div>
      {data.airportInfo && (
        <>
          <div className="fontSize32">
            {transformToHtml(data.airportInfo.airport)}{" "}
            {transformToHtml(data.airportInfo.airportCode)}
          </div>
          <div className="fontSize18 lh16">{transformToHtml(data.airportInfo.airportName)}</div>
          {data.airportInfo.details?.texts?.[0] && (
            <div className="fontSize18 boldFont appendTop8">
              {transformToHtml(data.airportInfo.details.texts[0])}
            </div>
          )}
        </>
      )}
    </div>
  );
}
